let goalAdminSocket = null
let goalAdminConnected = false
let reconnectTO = null
let attempts = 0
const MAX_ATTEMPTS = 10


const ConnectWebSocketForGoalAdmin = (onMessage = () => {}, onStatus = () => {}) => {
  if (goalAdminSocket || goalAdminConnected) return

  const connect = () => {
    if (attempts >= MAX_ATTEMPTS) {
      onStatus('error')
      return
    }
    attempts++

    goalAdminSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=goal:admin`)
    onStatus('connecting')

    goalAdminSocket.onopen = () => {
      goalAdminConnected = true
      attempts = 0
      onStatus('connected')
    }

    goalAdminSocket.onclose = () => {
      goalAdminConnected = false
      goalAdminSocket = null
      onStatus('reconnecting')
      reconnectTO = setTimeout(connect, 3000)
    }

    goalAdminSocket.onerror = () => {
      onStatus('error')
    }

    goalAdminSocket.onmessage = (evt) => {
      try {
        const payload = JSON.parse(evt.data)
        onMessage(payload)
      } catch (e) { /* noop */ }
    }
  }

  connect()
}

const DisconnectWebSocketForGoalAdmin = () => {
  try {
    if (goalAdminSocket) {
      goalAdminSocket.onopen = null
      goalAdminSocket.onclose = null
      goalAdminSocket.onerror = null
      goalAdminSocket.onmessage = null
      goalAdminSocket.close()
      goalAdminSocket = null
      goalAdminConnected = false
      clearTimeout(reconnectTO)
    }
  } catch { /* noop */ }
}

export { ConnectWebSocketForGoalAdmin, DisconnectWebSocketForGoalAdmin };